import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { createPortal } from "react-dom";
// import PropertyDropdown from "./PropertyDropdown";
import TopRightPartnersDropdown from "./TopRightPartnersDropdown";
import tw from "tailwind-styled-components";
import axios from "axios";
import Config from "../Config";
import TopSearchDropdown from "../Components/TopSearchDropdown";
import { useLocation, useNavigate } from "react-router-dom";
import SideModal from "./SideModal";
import { MdOutlinePendingActions } from "react-icons/md";
import PendingTasksModal from "./PendingTask";
import TopRightStaffDropdown from "./TopRightStaffDropdown";
import { FiActivity } from "react-icons/fi";
import ActivityLogsModal from "./ActivityLogs/ActivityLogsModalX";

const TopNavbar = () => {
  const navigate = useNavigate();
  const searchRef = useRef(null);
  const user = useSelector((state) => state.UserReducer.user);
  const properties = useSelector((state) => state.PropertyReducer.property);
  const partners = useSelector((state) => state.PartnersReducer.partners);
  const staffClients = useSelector((state) => state?.StaffClientReducer?.staffClients || []);
  const location = useLocation();
  // const partners = useSelector((state) => state.PartnersReducer.partners);
  const pendingTasks = useSelector((state) => state.PendingTasksReducer?.pendingTasks);
  const [isActivityOpen, setIsActivityOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [query, setQuery] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isPendingTasksOpen, setIsPendingTasksOpen] = useState(false);
  const [pendingTasksCount, setPendingTasksCount] = useState(0);
  const isDashboardRoute = location.pathname === '/' ||
    location.pathname === '/dashboard';

  useEffect(() => {
    if (pendingTasks && isDashboardRoute) {
      let count = 0;

      if (pendingTasks.totalPendingTasks > 0) {
        count = pendingTasks.totalPendingTasks;
      }
      setPendingTasksCount(count);
    } else {
      setPendingTasksCount(0);
    }
  }, [pendingTasks, isDashboardRoute]);

  const fetchFunction = async () => {
    const response = await axios.get(`${Config.apiUrl}/tenant/search/web?searchVal=${query}`, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
    return response.data;
  };

  useEffect(() => {
    if (query.length < 2) {
      setData([]);
      setSearchResult([]);
      setShowDropdown(false);
      return;
    }
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetchFunction();
        setSearchResult([]);
        if (response.list.length === 0) throw new Error("Failed to fetch data");
        const data = response?.list;
        setSearchResult(data);
        setShowDropdown(true);
      } catch (error) {
        setError(error.message);
        setShowDropdown(true);
      }
      setLoading(false);
    };
    const debounceTimer = setTimeout(fetchData, 500);
    return () => clearTimeout(debounceTimer);
  }, [query]);

  const handleSearchSelection = (selectedOption) => {
    const path = selectedOption?.status === 2
      ? `/tenantdetails/l/${selectedOption.id}/1`
      : `/tenantdetails/l/${selectedOption.id}`;

    navigate(path, {
      state: {
        tabName: 'Passbook',
        tabKey: "totalDues",
      },
    });
    setShowDropdown(false);
    setQuery("");
  };

  const handleSearchChange = (e) => {
    setError(null);
    setQuery(e.target.value);
    if (e.target.value.length >= 2) {
      setShowDropdown(true);
    }
  };

  const handleSearchFocus = () => {
    if (query.length >= 2 && (searchResult.length > 0 || error)) {
      setShowDropdown(true);
    }
  };
  const handlePendingTasksClick = () => {
    setIsPendingTasksOpen(true);
  };

  const handlePendingTasksClose = () => {
    setIsPendingTasksOpen(false);

  };
  //border-b border-gray-200
  return (
    <>
      <div className="bg-white/95 backdrop-blur-md fixed top-0 transition-all duration-300
          left-0 lg:left-60 
          w-full lg:w-[calc(100%-15rem)]">
        <div className="h-[65px] flex items-center justify-between px-4 md:px-6">
          {user.userType !== 5 &&
            <div className="flex items-center space-x-2 hidden md:flex ml-6">
              <SearchContainer ref={searchRef} className="hidden md:block ml-10 lg:ml-2 w-[360px]">
                {/* <SearchContainer className="relative w-[360px]"> */}
                <div className="
                    flex items-center gap-3
                    bg-[#F4F8FB]
                    rounded-xl
                    px-4 h-[48px]
                    transition-all duration-200   
                    focus-within:bg-white
                    focus-within:ring-2
                    focus-within:ring-[#0078BD]/10
                  ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                      d="M21 21l-4.35-4.35m1.85-5.65a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                  <input
                    type="text"
                    placeholder="Find a tenant by name, mobile or room no."
                    className="w-full bg-transparent outline-none text-sm text-gray-700 placeholder:text-gray-400"
                    value={query}
                    onChange={handleSearchChange}
                    onFocus={handleSearchFocus}
                  />
                </div>
                {showDropdown && searchResult && searchResult.length > 0 && (
                  createPortal(
                    <TopSearchDropdown
                      onChange={handleSearchSelection}
                      options={searchResult}
                      anchorRef={searchRef}
                      setShowDropdown={setShowDropdown}
                    />,
                    document.body
                  )
                )}
                {showDropdown && error != null && (
                  <ul className="
                    absolute mt-2 bg-white border border-gray-200
                    rounded-lg shadow-lg
                    max-h-48 overflow-y-auto
                    w-full z-50
                  ">
                    <li className="px-4 py-2 text-gray-500 text-sm">No results found</li>
                  </ul>
                )}
              </SearchContainer>

            </div>}
          <div className="md:hidden flex-1"></div>


          {(user.userType === Config.USER_TYPE.CLIENT) && partners?.length >= 1 &&
            <div className="flex items-center md:gap-6 gap-2">
              {/* <PropertyDropdown properties={properties} /> */}
              {isDashboardRoute && (
                <div className="relative">
                  <button
                    onClick={handlePendingTasksClick}
                    className="flex items-center justify-center w-11 h-11 rounded-xl bg-[#F4F8FB] hover:bg-[#EAF6FD] transition-all duration-200"
                    title="Pending Tasks"
                  >
                    <MdOutlinePendingActions className="w-5 h-5 text-gray-600" />
                    {pendingTasksCount > 0 && (
                      <span className="absolute -top-2 -right-2.5 bg-rose-500 text-white text-[10px] font-semibold rounded-full w-6 h-6 flex items-center justify-center">
                        {pendingTasksCount > 99 ? "99+" : pendingTasksCount}
                      </span>
                    )}
                  </button>
                </div>
              )}
              <div className="relative">
                <button
                  onClick={() => setIsActivityOpen(true)}
                  className="flex items-center justify-center
                    w-11 h-11 rounded-xl
                    bg-[#F4F8FB]
                    hover:bg-[#EAF6FD]
                    transition-all duration-200"
                  title="Recent Activity"
                >
                  <FiActivity className="w-5 h-5 text-gray-600" />

                  {/* Unread Indicator */}
                  <span
                    className="absolute top-2 right-2
                      w-2.5 h-2.5 rounded-full
                      bg-primary-color/90 ring-2 ring-white"
                  />
                </button>
              </div>
              
              <TopRightPartnersDropdown partners={partners} />
            </div>
          }

          {user.userType === Config.USER_TYPE.STAFF && staffClients?.length >= 1 &&
            <div className="flex items-center md:gap-6 gap-2">
              <TopRightStaffDropdown staffClients={staffClients} />
            </div>
          }
        </div>
      </div>

      <div className="h-16"></div>
      <SideModal
        isOpen={isPendingTasksOpen}
        onClose={handlePendingTasksClose}
        level="high"
      >
        <PendingTasksModal
          onClose={handlePendingTasksClose}
          pendingTasks={pendingTasks}
        />
      </SideModal>

      <SideModal
        isOpen={isActivityOpen}
        onClose={() => setIsActivityOpen(false)}
        level="high"
      >
        <ActivityLogsModal
          onClose={() =>
            setIsActivityOpen(false)
          }
        />
      </SideModal>
    </>
  );
};

const SearchContainer = tw.div`relative`;

export default TopNavbar;
